import React from "react";
import SidebarAdmin from "./Layout/Sidebar/Index";
import HeaderAdmin from "./Layout/Header/Index";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <SidebarAdmin />
      <HeaderAdmin />
      <div className="main-wrapper">
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
